<div class="bg-white p-6 rounded-xl shadow-md max-w-xl mx-auto">
  <h2 class="text-xl font-semibold text-gray-800 mb-4">Update to Public Servant</h2>

  <p class="text-sm text-gray-700 mb-6">
    By confirming, you agree that your account will be updated to reflect your status as a Public Servant.
    This action may allow additional features intended for verified government personnel.
  </p>

  <button
    mat-raised-button
    color="primary"
    (click)="confirmUpdate(true)"
    [disabled]="isSubmitting"
    class="w-full mb-3"
  >
    <mat-progress-spinner
      *ngIf="isSubmitting"
      diameter="20"
      mode="indeterminate"
      color="primary">
    </mat-progress-spinner>
    <span *ngIf="!isSubmitting">Confirm Update to Public Servant</span>
  </button>

  <button
    mat-stroked-button
    color="warn"
    (click)="confirmUpdate(false)"
    class="w-full"
  >
    Don't show this again
  </button>
</div>
